import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, Timer } from 'lucide-react';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 3
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <section className="py-12 md:py-16 bg-wood-dark text-cream relative overflow-hidden wood-texture" data-id="element-64">
      <div className="absolute inset-0 bg-wood-dark/90 mix-blend-multiply" data-id="element-65"></div>
      <div className="container mx-auto px-4 relative z-10 text-center max-w-2xl" data-id="element-66">
        <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-67">
          <a href="https://solucionstore.shop/cart/45476813504703:1" target="_blank" rel="noopener noreferrer" className="flex-1 bg-white/10 border border-white/20 hover:border-amber rounded-xl p-5 transition-all hover:-translate-y-1 block" data-id="element-68">
            <p className="text-lg font-bold text-white mb-2" data-id="element-69">🔹 $19.990 ARS</p>
            <span className="bg-amber text-wood-dark font-black px-4 py-2 rounded-lg text-sm inline-block" data-id="element-70">
              → QUIERO MI SUPER COMBO
            </span>
          </a>
          <a href="https://solucionstore.shop/cart/45476839882943:1" target="_blank" rel="noopener noreferrer" className="flex-1 bg-amber/10 border-2 border-amber rounded-xl p-5 transition-all hover:-translate-y-1 block" data-id="element-71">
            <p className="text-lg font-bold text-amber-light mb-2" data-id="element-72">
              🔶 $27.990 ARS ⭐
            </p>
            <span className="bg-amber text-wood-dark font-black px-4 py-2 rounded-lg text-sm inline-block" data-id="element-73">
              → QUIERO EL COMBO + MICRO-FÁBRICA
            </span>
          </a>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-3 text-xs text-cream/60" data-id="element-74">
          <span className="flex items-center" data-id="element-75">
            <ShieldCheck className="w-3.5 h-3.5 mr-1 text-amber" data-id="element-76" /> Pago seguro
          </span>
          <span className="text-wood-light" data-id="element-77">|</span>
          <span className="flex items-center" data-id="element-78">
            <Lock className="w-3.5 h-3.5 mr-1 text-amber" data-id="element-79" /> Acceso en 5 min
          </span>
          <span className="text-wood-light" data-id="element-80">|</span>
          <span className="flex items-center" data-id="element-81">
            <ShieldCheck className="w-3.5 h-3.5 mr-1 text-amber" data-id="element-82" /> Garantía 7
            días
          </span>
        </div>
        <p className="text-xs text-cream/40 mt-3" data-id="element-83">
          Mercado Pago | Tarjeta | Transferencia
        </p>
      </div>
    </section>;
}